import { CREW_FILE_MAX_BYTES, type CrewFileInput, parseCrewFile } from '../crew-files.js';
import { DomainError } from '../errors.js';

/**
 * Teklif belgesi (04.11 notları D1; ADR 0168): portala kayıtlı olmayan tedarikçinin kâğıt ya da
 * e-postayla gelen teklifini ofis elle girer ve tedarikçinin belgesini (PDF ya da görüntü) ekler.
 * Saf kurallar: I/O yok. Belge değiştirilemez bir satırdır; yeni belge eskisini silmez.
 *
 * Biçim personel dosyasıyla aynıdır (ADR 0164): PDF, JPEG, PNG; en çok 10 MB; tür içerikten.
 */
export const QUOTATION_DOCUMENT_MAX_BYTES = CREW_FILE_MAX_BYTES;

export type QuotationDocumentInput = CrewFileInput;

/** Ad, 1 bayt–10 MB (`FILE_TOO_LARGE`), tür PDF/JPEG/PNG (`FILE_TYPE_MISMATCH`), SHA-256. */
export function parseQuotationDocument(input: QuotationDocumentInput): QuotationDocumentInput {
  return parseCrewFile(input);
}

/**
 * Belge yalnız ofisin elle girdiği teklife eklenir. Portal teklifi tedarikçinin kendi hesabıyla
 * gönderdiği değiştirilemez sürümdür (ADR 0111 §C); ofis ona ek koymaz (`PORTAL_QUOTATION`).
 */
export function assertQuotationDocumentAllowed(quotation: { source: string | null }): void {
  if (quotation.source === 'portal') throw new DomainError('PORTAL_QUOTATION');
}
